export enum RateType {
	Flat = 1,
	Fixed = 2,
	Variable = 3,
	Temporary = 4,
	Overnight = 6,
}
